<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Выполняемые процедуры</h2>
          <div class="px-3"></div>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-card tile flat>
          <v-card-text>
            <v-text-field
              label="Имя процедуры"
              v-model="iadminprocedureid"
              :disabled="inaction"
            ></v-text-field>
            <v-btn
            color="crimson"
            :disabled="!iadminprocedureid || inaction"
            @click="executeProcedure()"
            >го</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Procedures',
  data: () => ({
    iadminprocedureid: null,
    inaction: false
  }),
  methods: {
    async executeProcedure () {
      try {
        this.inaction = true
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'execute-procedure',
          pl: { adminprocedureid: this.iadminprocedureid }
        })
        this.iadminprocedureid = null
        this.$store.dispatch('snack', meta)
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.inaction = false
      }
    },
  },
}
</script>

<style>
</style>
